import React, { Component } from 'react';
import { connect } from 'react-redux';
import CommonHeader from '../../util_components/common_header';
import Button from '../../util_components/button';
import * as actions from '../../../redux/action_creators';
import { post_api, get_api, delete_api } from '../../../redux/api_funcs';
import { get_api_url } from '../../../utils/urls';

class HealthMarker extends Component {
  state = {
    loading: false,
    members: [],
    search_text: '',
    selected_student: null,
    show_dropdown: false,
    add_loading: false,
    add_error: null
  };

  componentDidMount() {
    this.load_members();
  }

  load_members = () => {
    this.setState({ loading: true });
    const url = get_api_url('/v2/cms_user/health_access/members');
    get_api(url, true)
      .then((res) => this.setState({ members: res.data.data || [], loading: false }))
      .catch(() => this.setState({ loading: false }));
  };

  on_search_change = (e) => {
    this.setState({
      search_text: e.target.value,
      selected_student: null,
      show_dropdown: false,
      add_error: null
    });
  };

  on_search_click = () => {
    const { search_text } = this.state;
    if (search_text.trim().length < 3) return;
    this.props.search_students({ search_param: search_text.trim() });
    this.setState({ show_dropdown: true });
  };

  on_search_key_press = (e) => {
    if (e.key === 'Enter') this.on_search_click();
  };

  on_select_student = (student) => {
    this.setState({
      selected_student: student,
      search_text: student.email,
      show_dropdown: false
    });
  };

  handle_add = () => {
    const { selected_student } = this.state;
    if (!selected_student) return;
    this.setState({ add_loading: true });
    const url = get_api_url('/v2/cms_user/health_access/members');
    post_api(url, { email: selected_student.email }, true)
      .then(() => {
        this.setState({
          search_text: '',
          selected_student: null,
          add_loading: false,
          add_error: null
        });
        this.load_members();
      })
      .catch((e) => {
        let add_error;
        try {
          add_error = e.response.data.message;
        } catch (err) {
          add_error = 'Could not add member. Please try again.';
        }
        this.setState({ add_loading: false, add_error });
      });
  };

  handle_remove = (uuid) => {
    const url = get_api_url(`/v2/cms_user/health_access/members/${uuid}`);
    delete_api(url, true).then(() => this.load_members());
  };

  render_dropdown = () => {
    const { show_dropdown, search_text } = this.state;
    const { search_students_list, student_search_status } = this.props;

    if (!show_dropdown || !search_text) return null;

    if (student_search_status === 'loading') {
      return (
        <div style={dropdown_style}>
          <div style={dropdown_item_style}>Searching...</div>
        </div>
      );
    }

    if (!search_students_list.length) {
      return (
        <div style={dropdown_style}>
          <div style={dropdown_item_style}>No students found</div>
        </div>
      );
    }

    return (
      <div style={dropdown_style}>
        {search_students_list.map((student) => (
          <div
            key={student.student_uuid}
            style={dropdown_item_style}
            onMouseDown={() => this.on_select_student(student)}
          >
            {student.email}
          </div>
        ))}
      </div>
    );
  };

  render_table = () => {
    const { members } = this.state;
    if (members.length === 0) {
      return (
        <div style={{ color: 'var(--text-muted)', marginTop: '20px', fontSize: '14px' }}>
          No data found.
        </div>
      );
    }
    return (
      <div className="cus-table" style={{ marginTop: '20px' }}>
        <div className="ct-row ct-h">
          <div className="ct-col">Student Name</div>
          <div className="ct-col">Email</div>
          <div className="ct-col ct-hf">Status</div>
          <div className="ct-col ct-hf">Action</div>
        </div>
        {members.map((member) => (
          <div className="ct-row" key={member.student_uuid}>
            <div className="ct-col ct-sm-font">
              <a
                href={`/studentprofile?id=${member.student_uuid}`}
                style={{
                  color: 'var(--text-primary)',
                  textDecoration: 'underline',
                  fontWeight: 'bold'
                }}
              >
                {member.name || '—'}
              </a>
            </div>
            <div className="ct-col ct-sm-font">
              <a
                href={`/studentprofile?id=${member.student_uuid}`}
                style={{
                  color: 'var(--text-primary)',
                  textDecoration: 'underline',
                  fontWeight: 'bold'
                }}
              >
                {member.email || '—'}
              </a>
            </div>
            <div className="ct-col ct-hf ct-sm-font">{member.sync_status || '—'}</div>
            <div className="ct-col ct-hf">
              <Button type="secondary" onClick={() => this.handle_remove(member.student_uuid)}>
                Remove
              </Button>
            </div>
          </div>
        ))}
      </div>
    );
  };

  render() {
    const { loading, search_text, selected_student, add_loading, add_error } = this.state;
    return (
      <CommonHeader loading={loading} title="Health Marker">
        <div style={{ display: 'inline-block' }}>
          <div
            style={{
              position: 'relative',
              display: 'inline-flex',
              gap: '10px',
              alignItems: 'center',
              marginBottom: add_error ? '4px' : '8px'
            }}
          >
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                value={search_text}
                onChange={this.on_search_change}
                onBlur={() => this.setState({ show_dropdown: false })}
                onKeyPress={this.on_search_key_press}
                placeholder="Search student name..."
                style={{
                  padding: '8px 12px',
                  border: '1px solid var(--border-default)',
                  borderRadius: '4px',
                  background: 'var(--input-bg)',
                  color: 'var(--input-text)',
                  fontSize: '14px',
                  width: '300px'
                }}
              />
              {this.render_dropdown()}
            </div>
            <Button disabled={search_text.trim().length < 3} onClick={this.on_search_click}>
              Search
            </Button>
            <Button disabled={!selected_student || add_loading} onClick={this.handle_add}>
              {add_loading ? 'Adding...' : 'Add'}
            </Button>
          </div>
          {add_error && (
            <div style={{ color: 'var(--state-error)', fontWeight: 'bold', fontSize: '13px' }}>
              {add_error}
            </div>
          )}
        </div>
        {this.render_table()}
      </CommonHeader>
    );
  }
}

const dropdown_style = {
  position: 'absolute',
  top: '100%',
  left: 0,
  width: '300px',
  background: 'var(--surface-card)',
  border: '1px solid var(--border-default)',
  borderRadius: '4px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  zIndex: 100,
  maxHeight: '220px',
  overflowY: 'auto'
};

const dropdown_item_style = {
  padding: '10px 12px',
  fontSize: '14px',
  color: 'var(--text-primary)',
  cursor: 'pointer',
  borderBottom: '1px solid var(--border-default)'
};

const mapStateToProps = (state) => ({
  search_students_list: state.students.search_students_list,
  student_search_status: state.loading.student_search_status
});

const mapDispatchToProps = (dispatch) => ({
  search_students: (payload) => dispatch(actions.search_students(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(HealthMarker);
